import React from 'react'
import { useIntl } from 'react-intl'
import { AppMessageKeys } from '../../shared/translations/messages.ts'
import { Icon, IconName } from '../../shared/ui/icon/icon.tsx'
import { urls } from '../../shared/urls.ts'
import { useLocation, useNavigate } from 'react-router-dom'
import { NAVBAR_EXCEPTIONS } from '../../shared/data/navbar.ts'
import { AnimatePresence, motion } from 'framer-motion'
import { cn } from '../../shared/lib/utils.ts'

interface NavItem {
  text: AppMessageKeys
  icon: IconName
  url: string
}

const navbarItems: NavItem[] = [
  {
    text: 'navbar.main',
    icon: 'home',
    url: urls.main,
  },
  {
    text: 'navbar.lessons',
    icon: 'navStar',
    url: urls.learningProfile(),
  },
  {
    text: 'navbar.vocabPlus',
    icon: 'book',
    url: urls.practice,
  },
  {
    text: 'navbar.progress',
    icon: 'trendUp',
    url: urls.progress,
  },
  {
    text: 'navbar.profile',
    icon: 'profile2',
    url: urls.profile(),
  },
]

export function Navbar() {
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const isException = NAVBAR_EXCEPTIONS.includes(location.pathname)

  const getIsActive = (url: string) => {
    return location.pathname.includes(url) && url !== ''
  }

  return (
    <AnimatePresence mode="wait">
      {!isException && (
        <motion.nav
          aria-label="main menu"
          className="fixed inset-x-0 bottom-0 z-50 flex border-t border-gray bg-white pb-[env(safe-area-inset-bottom,0px)]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.1 }}
        >
          {navbarItems.map((item) => {
            const isActive = getIsActive(item.url)
            return (
              <button
                key={item.text}
                type="button"
                id={item.text}
                onClick={() => {
                  navigate(item.url)
                }}
                className={cn(
                  'flex h-68 flex-1 flex-col items-center justify-center gap-4 text-10 font-semibold',
                  isActive
                    ? 'font-extrabold text-main'
                    : 'text-gray8',
                )}
              >
                <Icon iconName={item.icon} size="sm" />
                <span className="whitespace-nowrap">
                  {intl.formatMessage({ id: item.text })}
                </span>
              </button>
            )
          })}
        </motion.nav>
      )}
    </AnimatePresence>
  )
}
